export enum ReportIncidentStep {
  BasicInformation = 1,
  PeopleInvolved = 2
}
